import NumOfIntrosModule from "./NumOfIntrosModule";
import MarketingSaga from "../../redux/sagas/marketing";
import NumOfIntrosReducer from "../../redux/reducers/numOfIntros";

export default {
  Component: NumOfIntrosModule,
  moduleName: "numOfIntros",
  saga: MarketingSaga("numOfIntros"),
  reducer: NumOfIntrosReducer
};
